import { createContext } from 'react';

const initialContext = {
  flowType: 'in-app' as const,
};

interface upgradeFlowContextValues {
  flowType: 'in-app' | 'onboarding';
}

const upgradeFlowContext = createContext<upgradeFlowContextValues>(initialContext);

export { upgradeFlowContext };
